import { useEffect } from 'react';

type UseInterruptionsUiEffectsParams = Readonly<{
  enabled: boolean;
  reset: () => void;
}>;

const useInterruptionsUiEffects = ({ enabled, reset }: UseInterruptionsUiEffectsParams) => {
  useEffect(() => {
    if (!enabled) {
      reset();
    }
  }, [enabled, reset]);
};

export default useInterruptionsUiEffects;
